<template>
  <div>
    <template v-if="loading_step === false">
    <div class="row">
      <div class="col s12 m12 l4 xl4 profile-image-wrapper">
        <img v-if="perfil_data.foto_url != null" v-bind:src="`${url_storage}/${perfil_data.foto_url}?w=250&q=100`" alt="" class="profile_image">
        <i v-else class="material-icons no-photo">person</i>
      </div>
      <div class="row">
        <div class="col s12 m12 l8 xl8 no-padding">
          <div class="input-field col s12">
            <input v-bind:value="perfil.nome" v-bind:disabled="perfil.pf_cpf_valid === true" ref="nome" type="text">
            <label for="nome">Nome</label>
          </div>
          <div class="input-field col s12">
            <input v-model="perfil.nome_social" ref="nome_social" type="text">
            <label for="nome_social">Nome Social</label>
          </div>
          <div class="input-field col s12 m6 cpf-wrapper">
            <input v-model="perfil.cpf" v-mask="['###.###.###-##']" ref="cpf" type="text" v-bind:class="{'invalid': error_fields['cpf']}" v-bind:disabled="perfil.pf_cpf_valid === true">
            <label for="cpf">CPF</label>
            <span v-if="error_fields['cpf']" class="helper-text" v-bind:data-error="'Um CPF válido deve ser informado'"></span>
          </div>
          <div class="input-field col s12 m6">
            <input v-model="perfil.nascimento" v-mask="['##/##/####']" ref="nascimento" type="text" v-bind:class="{'invalid': error_fields['nascimento']}" v-bind:disabled="perfil.pf_cpf_valid === true">
            <label for="nascimento">Data de nascimento</label>
            <span v-if="error_fields['nascimento']" class="helper-text" v-bind:data-error="'Uma data válida deve ser informada'"></span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="input-field col s12 m6">
          <select v-model="perfil.sexo" ref="sexo" id="sexo" v-bind:class="{'invalid': error_fields['sexo']}" required>
            <option value="" selected>Selecione</option>
            <option value="m6rj36">Masculino</option>
            <option value="f6rj36">Feminino</option>
            <option value="ud5xhh">Outro</option>
          </select>
          <label for="sexo">Sexo</label>
          <span v-if="error_fields['sexo']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="perfil.escol" ref="escol" id="escol" v-bind:class="{'invalid': error_fields['escol']}" required>
            <option v-bind:value="null" selected>Selecione</option>
            <option v-for="(escol, i) in meta.escolaridades" v-bind:key="i" v-bind:value="i">{{ escol }}</option>
          </select>
          <label for="escol">Escolaridade</label>
          <span v-if="error_fields['escol']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="perfil.genero" ref="genero" id="genero">
            <option value="" selected>Selecione</option>
            <option value="1">Mulher</option>
            <option value="2">Homem</option>
            <option value="3">Mulher Transgênero</option>
            <option value="4">Homem Transgênero</option>
            <option value="5">Travesti</option>
            <option value="6">Gênero neutro</option>
            <option value="7">Prefiro não me classificar</option>
          </select>
          <label for="genero">Gênero</label>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="perfil.orientacao_sexual" ref="orientacao_sexual" id="orientacao_sexual">
            <option value="" selected>Selecione</option>
            <option value="1">Heterossexual</option>
            <option value="2">Homosessual</option>
            <option value="3">Bissexual</option>
            <option value="4">Assexual</option>
            <option value="5">Prefiro não me classificar</option>
          </select>
          <label for="orientacao_sexual">Orientação Sexual</label>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="perfil.est_civil" ref="est_civil" id="est_civil" v-bind:class="{'invalid': error_fields['est_civil']}" required>
            <option v-bind:value="null" selected>Selecione</option>
            <option v-for="(est_c, i) in meta.estados_civis" v-bind:key="i" v-bind:value="i">{{ est_c }}</option>
          </select>
          <label for="est_civil">Estado civil</label>
          <span v-if="error_fields['est_civil']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m6">
          <select v-model="perfil.etnia" ref="etnia"  id="etnia" v-bind:class="{'invalid': error_fields['etnia']}" required>
            <option v-bind:value="null" selected>Selecione</option>
            <option v-for="(etnia, i) in meta.etnias" v-bind:key="i" v-bind:value="i">{{ etnia }}</option>
          </select>
          <label for="etnia">Etnia</label>
          <span v-if="error_fields['etnia']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m6">
          <input ref="nome_pai" v-model="perfil.nome_pai" type="text" v-bind:class="{'invalid': error_fields['nome_pai']}">
          <label for="nome_pai">Nome do pai</label>
          <span v-if="error_fields['nome_pai']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="perfil.nome_mae" ref="nome_mae" type="text" v-bind:class="{'invalid': error_fields['nome_mae']}">
          <label for="nome_mae">Nome da mãe</label>
          <span v-if="error_fields['nome_mae']" class="helper-text" v-bind:data-error="'Este campo deve ser preenchido'"></span>
        </div>
        <div class="input-field col s12 m4">
          <select id="pne" v-model="perfil.pne" @change="setPneStore(perfil.pne)">
            <option value="null" selected>Nenhum</option>
            <option v-for="(pne, i) in meta.pne" v-bind:key="i" v-bind:value="i">{{ pne }}</option>
          </select>
          <label for="pne">PCD</label>
        </div>
        <div class="input-field col s12 m4">
          <select disabled id="pf_pne_grau" v-model="perfil.pf_pne_grau">
            <option v-bind:value="null" selected>Nenhum</option>
            <option v-for="(grau, i) in meta.grau_pne" v-bind:key="grau" v-bind:value="i">{{ grau }}</option>
          </select>
          <label for="pf_pne_grau" class="ativar-label active">Grau de Deficiência</label>
          <div class="disable-field-warning"><i class="material-icons">info</i><p>Neste momento não é possível alterar esta informação. Se ela estiver divergente dos documentos apresentados, a correção será realizada pela equipe de digitação..</p></div>
        </div>
        <div class="input-field col s12 m4">
          <input v-model="perfil.pf_pne_data" v-mask="['##/##/####']" id="pf_pne_data" type="text">
          <label for="pf_pne_data" class="active">Início da Deficiência</label>
        </div>
      </div>
      <div class="step-actions">
        <button v-bind:disabled="step_completed === false" type="button" @click="submitStep" class="waves-effect waves-dark btn">Próximo</button>
      </div>
    </div>
    </template>
    <template v-else>
      <loading />
    </template>
  </div>
</template>
<script>
import {formataData, converteData, verificaData, validaCPF} from '@/assets/js/form-utils.js'
import Loading from '@/components/Loading.vue'
import axios from 'axios'
import { CONFIG } from '@/config/config.js'
import { mapActions } from 'vuex'
import sha1 from 'js-sha1'
let uuid_service = require("uuid")

let device_info = {
  'id': uuid_service.v4().substr(0, 30),
  'log': {
    'lat': -7.98391133, //BRA HeadQuarter's location
    'lon': -34.83876744
  }    
}

export default {
  name: 'Perfil',
  components: {
    loading: Loading
  },
  props: {
    stepper: Object,
    active_step: Number,
    perfil_data: Object,
    bio: Object,
  },
  data (){
    return {
      meta: this.$store.state.meta.data,
      pf_id: this.$store.state.user.pfId,
      loading_step: false,
      changed: false,
      step_completed: false,
      perfil: {
        foto_url: this.perfil_data.foto_url,
        nome: this.perfil_data.pf_nome,
        cpf: this.perfil_data.pf_cpf,
        pf_cpf_valid: this.perfil_data.pf_cpf_valid,
        nome_social: this.perfil_data.pf_nome_social,
        nascimento: (verificaData(this.perfil_data.pf_nascimento, 'YYYY-MM-DD') === true ? converteData(this.perfil_data.pf_nascimento) : null),
        sexo: this.perfil_data.pf_sexo,
        genero: this.perfil_data.pf_genero,
        orientacao_sexual: this.perfil_data.pf_orientacao_sexual,
        escol: this.perfil_data.pf_escol,
        est_civil: this.perfil_data.pf_est_civil,
        obito: (verificaData(this.perfil_data.pf_obito, 'YYYY-MM-DD') === true ? converteData(this.perfil_data.pf_obito,) : null),
        nome_pai: this.get_filiacao('P'),
        nome_mae: this.get_filiacao('M'),
        pf_obs: null,
        //BIO
        //nacionalidade: null,
        //naturalidade: null,
        pne: this.bio.pne,
        pf_pne_grau: this.bio.pf_pne_grau,
        pf_pne_data: (verificaData(this.bio.pne_data, 'YYYY-MM-DD') === true ? converteData(this.bio.pne_data) : null),
        etnia: this.bio.raca_cor
      },
      sha1_perfil: null,
      sha1_bio: null,
      sha1_etnia: null,
      error: null,
      error_fields: {
        nome_pai: false,
        nome_mae: false,
      },
      url_storage: CONFIG.URL_ARQUIVOS,
    }
  },
  computed: {
    pneAgora: function () {
      return this.perfil.pne
    }
  },
  methods: {
    ...mapActions({ setPneStore: 'setPne' }),
    getPayloadPerfil(){
      return {
        "cpf":  (this.perfil.pf_cpf_valid === false && this.perfil.cpf.replace(/[^0-9]/g, '') != this.perfil_data.pf_cpf && validaCPF(this.perfil.cpf) ? this.perfil.cpf : null),
        "nome":  (this.perfil.pf_cpf_valid === false ? this.perfil.nome : null),
        "nome_social": this.perfil.nome_social,
        "nascimento": (this.perfil.pf_cpf_valid === false && verificaData(this.perfil.nascimento) === true ? formataData(this.perfil.nascimento) : null),
        "filiacao": [
            {
              "pf_filiacao_tipo": "M",
              "pf_filiacao_nome": this.perfil.nome_mae
            },
            {
              "pf_filiacao_tipo": "P",
              "pf_filiacao_nome": this.perfil.nome_pai
            }
        ],
        "obito": null,
        "sexo": this.perfil.sexo,
        "genero": this.perfil.genero,
        "orientacao_sexual": this.perfil.orientacao_sexual,
        "escol": this.perfil.escol,
        "est_civil": this.perfil.est_civil
      }
    },
    getPayloadBio(){
      return {
        "pf_pne": this.perfil.pne,
        "pf_pne_data": (this.perfil.pf_pne_data ? formataData(this.perfil.pf_pne_data) : null),
        "pf_pne_grau": (this.perfil.pf_pne_grau ? `PCD_${this.perfil.pf_pne_grau}` : null),
        "device": device_info
      }
    },
    submitPerfil(){
      let perfil = this.getPayloadPerfil()
      //Percorre para remover do obj perfil as chaves que possuem valor null
      Object.keys(perfil).map((key) => {
        if(perfil[key] === null){
          delete perfil[key]
        }
      })

      return axios.patch(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/perfil/${this.pf_id}/`, {
        ...perfil,
        ...{
          'device': device_info
        }
      })

    },
    submitBioPNE(){
      return axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/pne/${this.pf_id}/`, this.getPayloadBio())
    },
    submitBioEtnia(){
      return axios.put(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/raca-cor/${this.pf_id}/`, {
        "pf_racacor": this.perfil.etnia,
        "device": device_info
      })
    },
    get_filiacao(tipo){
      if(this.perfil_data.filiacao){
        let parent = this.perfil_data.filiacao.filter(f => f['pf_filiacao_tipo'] === tipo)
        if(parent.length > 0){
          return parent[0]['pf_filiacao_nome']
        } else {
          return 'N/I'
        }
      }
    },
    async submitStep() {
      if(this.changed === true){
        this.$root.$emit('loadingHeader')
        this.loading_step = true
        let pefil_updated = Object.assign({}, this.perfil)

        if(sha1(JSON.stringify(this.getPayloadPerfil())) !== this.sha1_perfil){
          await this.submitPerfil()
          delete localStorage[`perfil_${this.pf_id}`]
        }

        if(this.perfil.pne !== null && sha1(JSON.stringify(this.getPayloadBio())) !== this.sha1_bio){
          await this.submitBioPNE()
        }

        if(this.perfil.etnia !== null && this.perfil.etnia !== this.sha1_etnia){
          await this.submitBioEtnia()
        }

        this.$root.$emit('stopLoadingHeader')
        this.loading_step = false
        this.$emit('moveNextStep', {step: 0, completed: this.step_completed})
      } else {
        this.$emit('moveNextStep', {step: 0, completed: this.step_completed})
      }
    },
    verificaStatusPasso(perfil){

      //Verificação especial do CPF
      if(validaCPF(this.perfil.cpf) === false){
        this.$set(this.error_fields, 'cpf', true)
        return false
      } else {
        this.$set(this.error_fields, 'cpf', false)
      }

      //Verificação especial do NASCIMENTO
      if(verificaData(this.perfil.nascimento) === false){
        this.$set(this.error_fields, 'nascimento', true)
        return false
      } else {
        this.$set(this.error_fields, 'nascimento', false)
      }

      let keys = [
        'nome', 'nome_pai', 'nome_mae', 'sexo', 'escol', 'est_civil', 'etnia'
      ]

      let selectKeys = [
        'sexo', 'escol', 'est_civil', 'etnia'
      ]

      let status = true //Até que se prove o contrário
      keys.forEach((key) => {
        if(this.perfil[key] == null || this.perfil[key] == ''){
          status = false
          this.$set(this.error_fields, key, true)
        } else {
          this.$set(this.error_fields, key, false)
        }
      })

      selectKeys.forEach((sKey) => {
        if(this.perfil[sKey] == null || this.perfil[sKey] == ''){
          status = false
          M.FormSelect.getInstance(this.$refs[sKey]).wrapper.classList.add('invalid')
        } else {
          M.FormSelect.getInstance(this.$refs[sKey]).wrapper.classList.remove('invalid')
        }
      })
      localStorage[`perfil_${this.pf_id}`] = JSON.stringify(this.perfil)
      return status
    },
    initStep(){
      setTimeout(() => {
        M.updateTextFields()
        M.FormSelect.init(document.querySelectorAll('select'))
        M.Tooltip.init(document.querySelectorAll('.tooltipped'))
        this.changed = false
      }, 200)
    }
  },
  watch: {
    perfil: {
      handler: function(updated_perfil, old_perfil){
        setTimeout(() => {
          this.changed = true
          this.step_completed = this.verificaStatusPasso(updated_perfil)

          this.$emit("updateEstadoCivil", updated_perfil.est_civil)
        }, 300)
      },
      deep: true
    }
  },
  mounted(){
    try {
      let saved = JSON.parse(localStorage[`perfil_${this.pf_id}`])
      if(!saved.nome){
        throw "Exception"
      } else {
        //this.perfil = saved
      }
    } catch (e){

    }
    this.initStep()
    this.sha1_perfil = sha1(JSON.stringify(this.getPayloadPerfil()))
    this.sha1_bio = sha1(JSON.stringify(this.getPayloadBio()))
    this.sha1_etnia = this.bio.raca_cor
  }
}
</script>


// WEBPACK FOOTER //
// src/components/steps/Perfil.vue